import { useMutation } from '@apollo/client';
import type { ApiOptions } from '../helpers';
import { GeneratePlayoutDetailPdfDocument } from './generate-playout-detail-pdf.generated';

export const useGeneratePlayoutDetailPdf = (
  options: ApiOptions<typeof GeneratePlayoutDetailPdfDocument> = {},
) =>
  useMutation(GeneratePlayoutDetailPdfDocument, {
    ...options,
  });
